(() => {
  if (window.__cdThemeReady) return;
  window.__cdThemeReady = true;

  const money = (cents) => {
    const value = Math.round(Number(cents) / 100);
    return `S/ ${value.toLocaleString('es-PE')}`;
  };

  const syncUiLock = () => {
    const lock = Boolean(document.querySelector('.cd-drawer.is-open, .cd-search-overlay.is-open'));
    document.documentElement.classList.toggle('cd-lock', lock);
    document.documentElement.classList.toggle('cd-ui-open', lock);
  };

  let pinStickies = () => {};

  const isDesktop = () => window.matchMedia('(min-width: 900px)').matches;

  const headerOffset = () => {
    const sticky = document.querySelector('.cd-header__sticky');
    const section = document.querySelector('.shopify-section.cd-header-section');
    const el = isDesktop() ? sticky || section : section;
    const height = el ? Math.round(el.getBoundingClientRect().height) : 0;
    return height + 16;
  };

  const watchScrollLock = () => {
    const html = document.documentElement;
    let lockedY = 0;
    const pins = [
      {
        pick: () => document.querySelector('.shopify-section.cd-header-section'),
        last: { top: 0, left: 0, width: 0 },
        fullBleed: true,
        zIndex: '50',
      },
    ];

    const remember = () => {
      pins.forEach((pin) => {
        const el = pin.pick();
        if (!el || el.dataset.cdPinned) return;
        const rect = el.getBoundingClientRect();
        pin.last = { top: rect.top, left: rect.left, width: rect.width };
      });
    };

    const pinAll = () => {
      lockedY = window.scrollY;
      pins.forEach((pin) => {
        const el = pin.pick();
        if (!el || el.dataset.cdPinned) return;
        const rect = el.getBoundingClientRect();
        const top = rect.top < -80 ? pin.last.top : rect.top;
        const left = pin.fullBleed ? 0 : rect.width > 0 ? rect.left : pin.last.left;
        const width = pin.fullBleed ? el.offsetWidth : rect.width || pin.last.width;
        const spacer = document.createElement('div');
        spacer.setAttribute('data-cd-lock-spacer', '');
        spacer.style.height = `${el.offsetHeight}px`;
        if (!pin.fullBleed) spacer.style.width = `${width}px`;
        el.after(spacer);
        pin.spacer = spacer;
        el.dataset.cdPinned = '1';
        el.style.position = 'fixed';
        el.style.top = `${Math.round(top)}px`;
        el.style.left = pin.fullBleed ? '0' : `${Math.round(left)}px`;
        el.style.right = pin.fullBleed ? '0' : '';
        el.style.width = pin.fullBleed ? '100%' : `${Math.round(width)}px`;
        el.style.zIndex = pin.zIndex;
      });
    };

    const hasPinned = () => pins.some((pin) => pin.pick()?.dataset.cdPinned || pin.spacer);

    const unpinAll = () => {
      if (!hasPinned()) return;
      pins.forEach((pin) => {
        const el = pin.pick();
        if (el) {
          delete el.dataset.cdPinned;
          el.style.position = '';
          el.style.top = '';
          el.style.left = '';
          el.style.right = '';
          el.style.width = '';
          el.style.zIndex = '';
        }
        pin.spacer?.remove();
        pin.spacer = null;
      });
      window.scrollTo(0, lockedY);
    };

    pinStickies = pinAll;

    window.addEventListener('scroll', remember, { passive: true });
    window.addEventListener('resize', remember);
    remember();

    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('.m-cart-icon-bubble')) pinAll();
      },
      true
    );

    new MutationObserver(() => {
      if (html.classList.contains('prevent-scroll')) pinAll();
      else if (hasPinned()) unpinAll();
    }).observe(html, { attributes: true, attributeFilter: ['class'] });
  };

  const initNavPill = (nav) => {
    const pill = nav.querySelector('[data-cd-pill]');
    const scope = nav.querySelector('[data-cd-pill-scope]');
    const mega = nav.querySelector('[data-cd-mega]');
    const area = nav.hasAttribute('data-cd-mega-area') ? nav : nav.querySelector('[data-cd-mega-area]');
    if (!pill || !scope) return;

    const triggers = [...nav.querySelectorAll('[data-cd-mega-trigger]')];
    const pillItems = [...scope.querySelectorAll('[data-cd-nav-item]')];
    const items = triggers.length ? triggers : pillItems;
    const panels = [...nav.querySelectorAll('[data-cd-mega-panel]')];
    const banners = [...nav.querySelectorAll('[data-cd-mega-banner]')];
    const closers = [...nav.querySelectorAll('[data-cd-mega-close]')];

    const OPEN_MS = 110;
    const CLOSE_MS = 140;
    let openTimer;
    let closeTimer;
    let openId = null;
    let lastTrigger = null;

    const tintPill = (el) => {
      if (!el) {
        pill.style.background = '#f1f1f6';
        return;
      }
      if (el.classList.contains('cd-nav__item--sale')) {
        pill.style.background = 'rgba(220, 38, 38, 0.07)';
        return;
      }
      if (el.classList.contains('cd-nav__item--clearance')) {
        pill.style.background = 'rgba(91, 46, 234, 0.07)';
        return;
      }
      pill.style.background = '#f1f1f6';
    };

    const move = (el, full) => {
      if (!el) return;
      const parent = scope.getBoundingClientRect();
      const box = el.getBoundingClientRect();
      pill.style.left = `${box.left - parent.left}px`;
      pill.style.width = `${box.width}px`;
      pill.style.opacity = full ? '1' : '0.55';
      tintPill(el);
    };

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    };

    const setOpen = (id, trigger) => {
      if (!mega || !id) return;
      openId = id;
      lastTrigger = trigger || lastTrigger;
      mega.classList.add('is-open');
      mega.removeAttribute('aria-hidden');
      triggers.forEach((el) => {
        const on = el.dataset.cdMegaTrigger === id;
        el.setAttribute('aria-expanded', on ? 'true' : 'false');
        el.classList.toggle('is-open', on);
      });
      panels.forEach((panel) => {
        const on = panel.dataset.cdMegaPanel === id;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
      banners.forEach((banner) => {
        banner.classList.toggle('is-active', banner.dataset.cdMegaBanner === id);
      });
      if (lastTrigger) move(lastTrigger, true);
    };

    const closeMega = (restoreFocus) => {
      clearTimers();
      if (!mega) return;
      mega.classList.remove('is-open');
      mega.setAttribute('aria-hidden', 'true');
      triggers.forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
        el.classList.remove('is-open');
      });
      if (restoreFocus && lastTrigger) lastTrigger.focus();
      if (!scope.matches(':hover')) {
        pill.style.opacity = '0.55';
        tintPill(lastTrigger);
      }
      openId = null;
    };

    nav._cdCloseMega = closeMega;
    nav._cdMegaIsOpen = () => Boolean(mega && mega.classList.contains('is-open'));

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        move(item, true);
        if (!mega) return;
        clearTimers();
        const id = item.dataset.cdMegaTrigger;
        if (mega.classList.contains('is-open')) {
          setOpen(id, item);
        } else {
          openTimer = window.setTimeout(() => setOpen(id, item), OPEN_MS);
        }
      });
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setOpen(item.dataset.cdMegaTrigger, item);
      });
    });

    if (area) {
      area.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
      area.addEventListener('mouseleave', () => {
        clearTimers();
        closeTimer = window.setTimeout(() => closeMega(false), CLOSE_MS);
      });
    } else {
      scope.addEventListener('mouseleave', () => {
        pill.style.opacity = '0.55';
      });
    }

    closers.forEach((el) => {
      el.addEventListener('mouseenter', () => {
        if (el.hasAttribute('data-cd-nav-item')) move(el, true);
        clearTimers();
        closeTimer = window.setTimeout(() => closeMega(false), CLOSE_MS);
      });
    });

    const onEsc = (event) => {
      if (event.key !== 'Escape') return;
      if (!mega || !mega.classList.contains('is-open')) return;
      event.preventDefault();
      closeMega(true);
    };
    document.addEventListener('keydown', onEsc);
    nav._cdMegaEsc = onEsc;

    if (items[0]) move(items[0], false);
  };

  const initSearch = (root) => {
    const form = root.querySelector('[data-cd-search]');
    if (!form) return;
    const input = form.querySelector('[data-cd-search-input]');
    const list = root.querySelector('[data-cd-search-list]');
    const all = root.querySelector('[data-cd-search-all]');
    const url = form.dataset.suggestUrl;
    const overlay = root.hasAttribute('data-cd-search-overlay');
    if (!input || !list) return;
    let timer;

    const close = () => root.classList.remove('is-open');
    const open = () => {
      if (!overlay) root.classList.add('is-open');
    };

    const render = (products, query) => {
      list.innerHTML = products
        .map((product) => {
          const sku = product.sku || product.variants?.[0]?.sku || '';
          const type = product.product_type || product.type || '';
          const initial = (product.title || '?').trim().charAt(0).toUpperCase();
          const img = product.image || product.featured_image;
          const thumb = img
            ? `<img src="${img}" alt="${product.title}">`
            : initial;
          return `<a class="cd-search__row" href="${product.url}" onmousedown="event.preventDefault()">
            <span class="cd-search__thumb">${thumb}</span>
            <span class="cd-search__meta">
              <span class="cd-search__name">${product.title}</span>
              <span class="cd-search__sku">${[sku, type].filter(Boolean).join(' · ')}</span>
            </span>
            <span class="cd-search__price">${money(product.price)}</span>
          </a>`;
        })
        .join('');
      if (all) {
        all.textContent = query ? `Buscar “${query}” en todo el catálogo` : all.dataset.default || all.textContent;
        all.href = query ? `${form.action}?q=${encodeURIComponent(query)}` : form.action;
      }
    };

    const fetchSuggest = (query) => {
      const endpoint = `${url}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku`;
      fetch(endpoint)
        .then((res) => res.json())
        .then((data) => {
          const products = data.resources?.results?.products || [];
          render(products, query);
          open();
        })
        .catch(() => open());
    };

    input.addEventListener('focus', () => {
      fetchSuggest(input.value.trim());
    });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => fetchSuggest(input.value.trim()), 180);
    });
    if (!overlay) {
      input.addEventListener('blur', () => {
        setTimeout(close, 120);
      });
    } else {
      root._cdFetchSuggest = fetchSuggest;
      root._cdSearchInput = input;
    }
  };

  const initHeader = (header) => {
    const drawer = header.querySelector('[data-cd-drawer]');
    const searchOverlay = header.querySelector('[data-cd-search-overlay]');
    const menuBtn = header.querySelector('[data-cd-drawer-open]');

    const setExpanded = (btn, on) => {
      if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    };

    const resetDrill = () => {
      if (!drawer) return;
      drawer.querySelectorAll('[data-cd-level2]').forEach((panel) => {
        panel.hidden = true;
      });
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      setExpanded(menuBtn, false);
      resetDrill();
      syncUiLock();
    };

    const openDrawer = () => {
      if (!drawer) return;
      closeSearch();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      setExpanded(menuBtn, true);
      syncUiLock();
    };

    const closeSearch = () => {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      header.querySelectorAll('[data-cd-search-open]').forEach((btn) => setExpanded(btn, false));
      const input = searchOverlay._cdSearchInput;
      if (input) input.value = '';
      syncUiLock();
    };

    const openSearch = () => {
      if (!searchOverlay) return;
      closeDrawer();
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      header.querySelectorAll('[data-cd-search-open]').forEach((btn) => setExpanded(btn, true));
      syncUiLock();
      const input = searchOverlay._cdSearchInput;
      if (input) {
        requestAnimationFrame(() => {
          input.focus();
          if (typeof searchOverlay._cdFetchSuggest === 'function') searchOverlay._cdFetchSuggest(input.value.trim());
        });
      }
    };

    if (menuBtn) menuBtn.addEventListener('click', openDrawer);
    header.querySelectorAll('[data-cd-drawer-close]').forEach((btn) => btn.addEventListener('click', closeDrawer));
    header.querySelectorAll('[data-cd-search-open]').forEach((btn) => btn.addEventListener('click', openSearch));
    header.querySelectorAll('[data-cd-search-close]').forEach((btn) => btn.addEventListener('click', closeSearch));

    if (drawer) {
      drawer.querySelectorAll('[data-cd-drill]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.cdDrill;
          const panel = drawer.querySelector(`[data-cd-level2="${id}"]`);
          if (!panel) return;
          drawer.querySelectorAll('[data-cd-level2]').forEach((el) => {
            el.hidden = true;
          });
          panel.hidden = false;
          void panel.offsetWidth;
        });
      });
      drawer.querySelectorAll('[data-cd-drill-back]').forEach((btn) => {
        btn.addEventListener('click', resetDrill);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const nav = header.querySelector('[data-cd-nav]');
      if (nav && typeof nav._cdMegaIsOpen === 'function' && nav._cdMegaIsOpen()) {
        nav._cdCloseMega(true);
        return;
      }
      closeDrawer();
      closeSearch();
    });

    const onScroll = () => {
      header.classList.toggle('is-search-collapsed', window.scrollY > 90);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const initGallery = (root) => {
    const main = root.querySelector('[data-cd-main-image]');
    const videoHost = root.querySelector('[data-cd-main-video]');
    const thumbs = [...root.querySelectorAll('[data-cd-thumb]')];
    const items = [...root.querySelectorAll('[data-cd-pswp-item]')];
    const scroller = root.querySelector('[data-cd-slides]');
    const dotsWrap = root.querySelector('[data-cd-dots]');
    let index = 0;
    let ignoreClickUntil = 0;
    let dots = [];

    const pauseMedia = (scope = root) => {
      scope.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    };

    const showStage = (item) => {
      const type = item?.dataset.mediaType || 'image';
      const isVideo = type === 'video' || type === 'external_video';
      root.classList.toggle('is-video', isVideo);
      pauseMedia();
      items.forEach((el) => el.classList.toggle('is-active', el === item));
      const slideImg = item?.querySelector('.cd-pdp__slide-img');
      if (main) {
        main.hidden = true;
        if (!isVideo && slideImg) {
          const src = slideImg.currentSrc || slideImg.src;
          if (src) {
            main.src = src;
            main.alt = item.dataset.pswpAlt || slideImg.alt || main.alt;
          }
        }
      }
      if (!videoHost) return;
      videoHost.hidden = true;
      if (!isVideo) videoHost.innerHTML = '';
    };

    const goTo = (next) => {
      index = Math.max(0, Math.min(Math.max(items.length, 1) - 1, next));
      const item = items[index];
      if (item) showStage(item);
      thumbs.forEach((el) => {
        const on = Number(el.dataset.index) === index;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (scroller) {
        if (window.matchMedia('(max-width: 899px)').matches) {
          scroller.style.transform = `translate3d(${-index * 100}%, 0, 0)`;
        } else {
          scroller.style.transform = '';
        }
      }
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const currentSrc = main ? main.currentSrc || main.getAttribute('src') || '' : '';
    const initialThumb =
      thumbs.find((el) => el.classList.contains('is-active')) ||
      thumbs.find((el) => el.dataset.src && currentSrc && currentSrc.split('?')[0] === el.dataset.src.split('?')[0]) ||
      thumbs[0];
    if (initialThumb && initialThumb.dataset.index != null) {
      index = Number(initialThumb.dataset.index) || 0;
    }
    items.forEach((item) => {
      const img = item.querySelector('.cd-pdp__slide-img');
      const src = img ? img.currentSrc || img.getAttribute('src') : item.dataset.src;
      if (!src) return;
      if (img) img.loading = 'eager';
      const pre = new Image();
      pre.src = src;
    });
    goTo(index);

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index) || 0));
    });

    if (scroller && dotsWrap) {
      let startX = 0;
      let startY = 0;
      let tracking = false;
      dotsWrap.innerHTML = items
        .map((_, i) => `<button type="button" class="cd-pdp__dot${i === index ? ' is-active' : ''}" data-index="${i}" aria-label="${i + 1}"></button>`)
        .join('');
      dots = [...dotsWrap.children];
      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.index)));
      });
      root.addEventListener(
        'pointerdown',
        (event) => {
          if (window.pswp) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('[data-cd-dots], [data-cd-thumb], [data-cd-zoom], video, iframe, [data-cd-media], [data-cd-main-video]')) return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
        },
        { passive: true }
      );
      window.addEventListener(
        'pointerup',
        (event) => {
          if (!tracking) return;
          tracking = false;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy)) return;
          ignoreClickUntil = Date.now() + 400;
          goTo(index + (dx < 0 ? 1 : -1));
        },
        { passive: true }
      );
    }

    const Lightbox = window.MinimogLibs && window.MinimogLibs.PhotoSwipeLightbox;
    if (!Lightbox || !Lightbox.PhotoSwipe || !items.length) return;

    const dataSource = items.map((item) => {
      const type = item.dataset.mediaType || 'image';
      if (type === 'video' || type === 'external_video') {
        const source = item.querySelector('[data-cd-media]');
        return {
          html: `<div class="pswp__${type}">${source ? source.innerHTML : ''}</div>`,
          type,
          id: item.dataset.index,
        };
      }
      return {
        src: item.dataset.pswpSrc,
        width: parseInt(item.dataset.pswpWidth, 10) || 1200,
        height: parseInt(item.dataset.pswpHeight, 10) || 1200,
        alt: item.dataset.pswpAlt || '',
        id: item.dataset.index,
      };
    });

    const lightbox = new Lightbox({
      dataSource,
      bgOpacity: 1,
      close: false,
      zoom: false,
      arrowNext: false,
      arrowPrev: false,
      counter: false,
      preloader: false,
      pswpModule: Lightbox.PhotoSwipe,
    });

    lightbox.addFilter('thumbEl', (thumbEl, { id }) => {
      return (
        root.querySelector(`[data-cd-pswp-item][data-index="${id}"] img`) ||
        root.querySelector('[data-cd-main-image]') ||
        thumbEl
      );
    });

    lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
      const el =
        root.querySelector(`[data-cd-pswp-item][data-index="${id}"] img`) ||
        root.querySelector('[data-cd-main-image]');
      return el ? el.currentSrc || el.src : placeholderSrc;
    });

    lightbox.on('change', () => {
      if (!lightbox.pswp) return;
      pauseMedia();
      goTo(lightbox.pswp.currIndex);
    });

    lightbox.on('close', () => {
      pauseMedia(document);
    });

    const uiElements = [
      {
        name: 'm-close',
        order: 11,
        isButton: true,
        html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
        onClick: (event, el, pswp) => pswp.close(),
      },
      {
        name: 'm-arrowNext',
        order: 12,
        isButton: true,
        html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
        onClick: (event, el, pswp) => pswp.next(),
      },
      {
        name: 'm-arrowPrev',
        order: 10,
        isButton: true,
        html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c-4.686-4.686-4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
        onClick: (event, el, pswp) => pswp.prev(),
      },
    ];

    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement(uiElements[0]);
      if (dataSource.length > 1) {
        uiElements.slice(1).forEach((element) => lightbox.pswp.ui.registerElement(element));
      }
    });

    lightbox.init();

    const openAt = (at) => {
      pauseMedia();
      lightbox.loadAndOpen(Math.max(0, Number(at) || 0));
    };

    root.addEventListener('click', (event) => {
      if (Date.now() < ignoreClickUntil) return;
      if (event.target.closest('[data-cd-thumb], [data-cd-dots]')) return;
      if (event.target.closest('video, iframe, [data-cd-media], [data-cd-main-video]')) return;
      if (!event.target.closest('[data-cd-zoom], [data-cd-main-image], .cd-pdp__slide, .cd-pdp__stage')) return;
      event.preventDefault();
      openAt(index);
    });
  };

  const initTabs = (root) => {
    const tabs = [...root.querySelectorAll('[data-cd-tab]')];
    const panels = [...root.querySelectorAll('[data-cd-panel]')];
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.cdTab;
        tabs.forEach((el) => el.classList.toggle('is-active', el === tab));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.cdPanel !== id;
        });
      });
    });
  };

  const initFacts = (root) => {
    const facts = [...root.querySelectorAll('.cd-pdp__fact')];
    if (!facts.length) return;
    const desktop = window.matchMedia('(min-width: 900px)');
    const sync = () => {
      facts.forEach((el, index) => {
        if (desktop.matches) {
          el.setAttribute('open', '');
          return;
        }
        if (index === 0) el.setAttribute('open', '');
        else el.removeAttribute('open');
      });
    };
    desktop.addEventListener('change', sync);
    sync();
  };

  const initAbout = (root) => {
    const about = root.querySelector('[data-cd-about]');
    const toggle = about?.querySelector('[data-cd-about-toggle]');
    if (toggle && about) {
      toggle.addEventListener('click', () => {
        const on = about.classList.toggle('is-expanded');
        toggle.textContent = on ? toggle.dataset.less : toggle.dataset.more;
      });
    }

    const tabs = root.querySelector('[data-cd-tabs]');
    const specLink = root.querySelector('.cd-pdp__more--specs');
    if (!tabs || !specLink) return;
    specLink.addEventListener('click', (event) => {
      event.preventDefault();
      const specsTab = tabs.querySelector('[data-cd-tab="specs"]');
      if (specsTab) specsTab.click();
      const top = tabs.getBoundingClientRect().top + window.scrollY - headerOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  };

  const clampQty = (input) => {
    const min = Number(input.min || 1);
    const max = Number(input.max || 99);
    const next = Math.min(max, Math.max(min, parseInt(input.value, 10) || min));
    input.value = String(next);
    return next;
  };

  const initQty = (root) => {
    const wrap = root.querySelector('[data-cd-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    wrap.querySelectorAll('button[data-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        input.value = String(clampQty(input) + Number(btn.dataset.step));
        clampQty(input);
      });
    });
    input.addEventListener('change', () => clampQty(input));
  };

  const openMiniCart = (response) => {
    const cartDrawer = document.querySelector('m-cart-drawer');
    const settings = window.MinimogSettings || {};
    if (!settings.use_ajax_atc) {
      window.location = settings.routes?.cart || '/cart';
      return;
    }
    if (cartDrawer && settings.enable_cart_drawer) {
      if (window.MinimogTheme?.Notification && window.MinimogStrings?.itemAdded) {
        window.MinimogTheme.Notification.show({
          target: cartDrawer.querySelector('m-cart-items'),
          method: 'prepend',
          type: 'success',
          message: window.MinimogStrings.itemAdded,
          delay: 400,
        });
      }
      pinStickies();
      cartDrawer.open();
    } else if (window.MinimogTheme?.Notification && window.MinimogStrings?.itemAdded) {
      window.MinimogTheme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'success',
        message: window.MinimogStrings.itemAdded,
        last: 3000,
        sticky: true,
      });
    }
    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
        cart: response,
        productVariantId: response.id,
      });
    }
  };

  const initRelated = (root) => {
    const box = root.querySelector('[data-cd-related]');
    if (!box || !box.dataset.url || box.querySelector('.cd-pdp__rec')) return;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      fetch(box.dataset.url)
        .then((res) => res.text())
        .then((html) => {
          const doc = document.createElement('div');
          doc.innerHTML = html;
          const next = doc.querySelector('[data-cd-related]');
          if (next) box.innerHTML = next.innerHTML;
        });
    }, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(box);
  };

  const initDock = (root) => {
    const dock = root.querySelector('[data-cd-dock]');
    const actions = root.querySelector('[data-cd-actions]');
    if (!dock || !actions) return;
    const update = () => {
      const past = actions.getBoundingClientRect().bottom < 0;
      dock.classList.toggle('is-visible', past);
      dock.setAttribute('aria-hidden', past ? 'false' : 'true');
    };
    update();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(update, { threshold: [0, 0.01, 1] });
      observer.observe(actions);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  };

  const initProductForm = (root) => {
    const form = root.querySelector('[data-cd-product-form], form.cd-pdp__form');
    if (!form || form.dataset.cdBound === 'true') return;
    form.dataset.cdBound = 'true';
    const atc = form.querySelector('[data-cd-atc]');
    const dockAtc = root.querySelector('[data-cd-dock-atc]');
    const qtyInput = form.querySelector('[data-cd-qty] input[name="quantity"], input[name="quantity"]');
    if (!atc) return;
    const idle = atc.innerHTML;
    const dockIdle = dockAtc ? dockAtc.innerHTML : '';
    let submitting = false;
    const checkoutUrl = () => {
      const root = window.Shopify?.routes?.root || '/';
      return new URL('checkout', window.location.origin + root).pathname;
    };

    form.addEventListener('submit', async (event) => {
      const buyNow = event.submitter && event.submitter.hasAttribute('data-cd-buy-now');
      event.preventDefault();
      event.stopPropagation();
      if (submitting) return;
      submitting = true;
      const buyBtn = form.querySelector('[data-cd-buy-now]');
      const buyIdle = buyBtn ? buyBtn.innerHTML : '';
      atc.disabled = true;
      if (buyBtn) buyBtn.disabled = true;
      if (dockAtc) dockAtc.disabled = true;
      if (buyNow && buyBtn) {
        buyBtn.innerHTML = '<span class="cd-spinner" aria-hidden="true"></span> Redirigiendo…';
      } else {
        atc.innerHTML = '<span class="cd-spinner" aria-hidden="true"></span> Agregando…';
      }
      const started = Date.now();
      try {
        const qty = qtyInput ? clampQty(qtyInput) : 1;
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        const formData = new FormData(form);
        formData.set('quantity', String(qty));
        formData.delete('checkout');
        formData.set('sections', sectionsToBundle.join(','));
        formData.set('sections_url', window.location.pathname);
        const addUrl = window.MinimogSettings?.routes?.cart_add_url || '/cart/add';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });
        const item = await response.json();
        if (item.status) throw item;
        if (buyNow) {
          window.location.href = checkoutUrl();
          return;
        }
        const wait = 900 - (Date.now() - started);
        if (wait > 0) await new Promise((resolve) => setTimeout(resolve, wait));
        atc.classList.add('is-success');
        atc.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7"></path></svg> Agregado';
        if (dockAtc) {
          dockAtc.classList.add('is-success');
          dockAtc.textContent = 'Agregado';
        }
        openMiniCart(item);
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: item } }));
        setTimeout(() => {
          atc.classList.remove('is-success');
          atc.innerHTML = idle;
          atc.disabled = false;
          if (buyBtn) {
            buyBtn.disabled = false;
            buyBtn.innerHTML = buyIdle;
          }
          if (dockAtc) {
            dockAtc.classList.remove('is-success');
            dockAtc.innerHTML = dockIdle;
            dockAtc.disabled = false;
          }
          submitting = false;
        }, 1600);
      } catch (error) {
        atc.innerHTML = idle;
        atc.disabled = false;
        if (buyBtn) {
          buyBtn.disabled = false;
          buyBtn.innerHTML = buyIdle;
        }
        if (dockAtc) {
          dockAtc.innerHTML = dockIdle;
          dockAtc.disabled = false;
        }
        submitting = false;
      }
    }, true);
  };

  document.addEventListener('DOMContentLoaded', () => {
    watchScrollLock();
    document.querySelectorAll('[data-cd-header]').forEach(initHeader);
    document.querySelectorAll('[data-cd-nav]').forEach(initNavPill);
    document.querySelectorAll('[data-cd-search-root]').forEach(initSearch);
    document.querySelectorAll('[data-cd-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-cd-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-cd-pdp]').forEach((root) => {
      initQty(root);
      initProductForm(root);
      initRelated(root);
      initFacts(root);
      initAbout(root);
      initDock(root);
    });
  });
})();
